if (!customElements.get("product-buy-with")) {
  customElements.define(
    "product-buy-with",
    class ProductBuyWith extends HTMLElement {
      constructor() {
        super();

        // --- Original upsell logic ---
        this.fields = this.querySelectorAll("input, select");
        this.fields.forEach((field) => {
          field.addEventListener("change", (e) => {
            this.adjustFormUpsells(field);
          });
        });
      }

      connectedCallback() {
        // --- Singleton listener setup for popups ---
        if (window.__infoPopupAbort) {
          console.log("[infoPopup] Previous listener found → aborting it");
          window.__infoPopupAbort.abort();
        }

        window.__infoPopupAbort = new AbortController();
        const { signal } = window.__infoPopupAbort;

        let lastHandledAt = 0;

        const onDocClick = (e) => {
          console.count("[infoPopup] onDocClick fired");
          console.log("[infoPopup] isTrusted:", e.isTrusted, "target:", e.target);

          // Debounce duplicate fast clicks
          const now = Date.now();
          if (now - lastHandledAt < 120) {
            console.log("[infoPopup] Skipping duplicate within 120ms");
            return;
          }
          lastHandledAt = now;

          if (window.innerWidth > 990) {
            console.log("[infoPopup] >990px → no action");
            return;
          }

          const inTitle = e.target.closest(".item-title");
          const inPopup = e.target.closest(".info-popup");

          console.log("[infoPopup] inTitle:", !!inTitle, "inPopup:", !!inPopup);

          // Clicked outside both → close all
          if (!inTitle && !inPopup) {
            console.log("[infoPopup] Outside both → closing all");
            document.querySelectorAll(".info-popup").forEach((p) => {
              p.classList.remove("is-open");
              p.style.display = "none";
              console.log("[infoPopup] Closed:", p);
            });
            return;
          }

          // Click inside popup → allow normal behavior
          if (inPopup) {
            console.log("[infoPopup] Click inside popup → no toggle or preventDefault");
            return;
          }

          // Clicked a title (not popup) → toggle popup
          if (inTitle) {
            console.log("[infoPopup] Clicked on item-title");

            // ✅ Prevent default (stop navigation, button submit, etc.)
            e.preventDefault();
            e.stopPropagation();

            const popup = inTitle.querySelector(".info-popup");
            console.log("[infoPopup] Popup inside title:", popup);

            if (!popup) {
              console.log("[infoPopup] No popup found inside this .item-title");
              return;
            }

            // Close all others
            document.querySelectorAll(".info-popup").forEach((p) => {
              if (p !== popup) {
                p.classList.remove("is-open");
                p.style.display = "none";
                console.log("[infoPopup] Closed other:", p);
              }
            });

            // Toggle current popup
            const willOpen = !popup.classList.contains("is-open");
            popup.classList.toggle("is-open", willOpen);
            popup.style.display = willOpen ? "block" : "none";
            console.log(`[infoPopup] ${willOpen ? "Opened" : "Closed"} current popup`);
          }
        };

        document.addEventListener("click", onDocClick, { signal });
        console.log("[infoPopup] Listener attached once");
      }

      disconnectedCallback() {
        // Clean up if the element is removed
        if (window.__infoPopupAbort) {
          console.log("[infoPopup] disconnectedCallback → aborting listener");
          window.__infoPopupAbort.abort();
          window.__infoPopupAbort = null;
        }
      }

      adjustFormUpsells(field) {
        let newId = "";
        const productId = field.closest(".buy-with-item").dataset.productId;

        if (field.tagName === "INPUT") {
          if (field.checked) {
            newId = field.value;
          }
        } else {
          if (field.value !== "empty") {
            newId = field.value;
          }
        }

        const hiddenFields = document.querySelectorAll(
          `input.buy-with-field[type="hidden"][data-product-id="${productId}"]`
        );

        if (hiddenFields.length > 0) {
          hiddenFields.forEach((hiddenField) => {
            if (newId !== "") {
              hiddenField.value = newId;
              hiddenField.setAttribute("name", "id[]");
            } else {
              hiddenField.removeAttribute("name");
            }
          });
        }
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", () => {
  const productForm = document.querySelector("product-info product-form");
  const floatingButtons = document.querySelector(".floating-buttons");
  const html = document.documentElement;

  if (productForm && floatingButtons) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          floatingButtons.classList.add("active");

          const h = floatingButtons.offsetHeight;
          html.style.setProperty('--bottom-add-height', `${h}px`);
        } else {
          floatingButtons.classList.remove("active");

          html.style.setProperty('--bottom-add-height', `0px`);
        }
      });
    }, { threshold: 0 });

    observer.observe(productForm);

    window.addEventListener("resize", () => {
      if (floatingButtons.classList.contains("active")) {
        const h = floatingButtons.offsetHeight;
        html.style.setProperty('--bottom-add-height', `${h}px`);
      }
    });
  }
});
